(function () {
   const buttons = document.querySelectorAll('.button--top');
   if(buttons.length > 0) {
       buttons.forEach(element => {
           element.addEventListener('click', () => {
               window.scrollTo({top: 0, behavior: 'smooth'});
           })
       })
   }
})();